import PropTypes from 'prop-types';
import React from 'react';

const style = {
  fontWeight: '400',
  color: '#004e63',
  textDecoration: 'none',
};

const Link = ({ href, children, target, rel }) => (
  <a style={style} href={href} target={target} rel={rel}>
    {children}
  </a>
);

Link.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node.isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
};

Link.defaultProps = {
  href: null,
  target: '_self',
  rel: null,
};

export default Link;
